// practiceFeatures.ts · v12.10.30 (#2256 the practice's feature switches, read from /me; cachedFeatureOn for Help and the first-run checklist) · 2026-11-03 · VoiceSpectrum AI
//
// v12.10.30 (#2256, Tushar 11/3): "if it is disabled then tenant can see it but can not activate it". Support Ops sets the switches
// (Workspaces › Features); the practice app only READS them from GET /api/t2/security/me -> features, and greys the matching switch.
// The server refuses the off -> on step anyway (409 feature_off); this is so the screen says why before anyone tries.
import { getCachedMe, useAccess } from './useAccess';

export type PracticeFeatureKey = 'ai' | 'voicemail' | 'call_back' | 'text_reply' | 'text_workspace';

/** Same defaults as VoiceSpectrum.Data.Features.PracticeFeatures (no row = AI on, Voicemail on, the rest off). */
const DEFAULTS: Record<PracticeFeatureKey, boolean> = { ai: true, voicemail: true, call_back: false, text_reply: false, text_workspace: false };

/** The note shown under a switch whose feature is off. */
export const FEATURE_OFF_NOTE = 'Not turned on for your practice - contact VoiceSpectrum Support.';

/** Pure lookup on a /me features map. Unknown (no map yet / an older API) -> the feature's default, so nothing greys before /me loads. */
export function featureOn(features: Record<string, boolean> | null | undefined, key: PracticeFeatureKey): boolean {
  const v = features?.[key];
  return typeof v === 'boolean' ? v : DEFAULTS[key];
}

/** Is this practice feature on? (from /me; the default while /me loads or failed). */
export function usePracticeFeature(key: PracticeFeatureKey): boolean {
  const { me } = useAccess();
  return featureOn(me?.features, key);
}

/**
 * v12.10.30 (#2256, Tushar 11/3 ~5:55 PM: "#the help topic of disabled feature will also be not available.") - the same answer outside React, from the last /me
 * (useAccess mirrors it before the query resolves, so a list memoised on `me` re-filters when it arrives). Not loaded -> the default.
 */
export function cachedFeatureOn(key: PracticeFeatureKey): boolean {
  return featureOn(getCachedMe()?.features, key);
}
